export function getControlledOverlayTextInputValue(value) {
    return value ?? '';
}
export function getControlledOverlaySelectValue(value) {
    return value ?? '';
}
